import { render, staticRenderFns } from "./descriptor-wrapper.vue?vue&type=template&id=6b9bd049"
import script from "./descriptor-wrapper.vue?vue&type=script&lang=ts"
export * from "./descriptor-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports